<template>
  <a-select
    :placeholder="placeholder"
    :disabled="disabled"
    :value="selectedValue"
    @change="handleChange"
    :showSearch="showSearch"
    :filterOption="showSearch && !filterByServer ? filterOption : false"
    @search="loadData"
    :notFoundContent="loading ? undefined : null"
    :mode="multiple ? 'multiple' : 'default'"
    :allowClear="allowClear"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small"/>
    <a-select-option v-for="(item, index) in dictOptions" :key="index" :value="item.value">
      <span style="display: inline-block;width: 100%" :title="item.text">
        {{ item.text }}
      </span>
    </a-select-option>
  </a-select>
</template>

<script>
  import { ajaxGetDictItems } from '@/api/api'
  import { getAction } from '@/api/manage'
  import debounce from 'lodash/debounce'

  export default {
    name: "JDictCodeSelectTag",
    props: {
      dictCode: {
        type: String,
        required: true
      },
      placeholder: {
        type: String,
        default: "请选择",
        required: false
      },
      triggerChange: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      value: {
        type: [String, Number, Array],
        default: ''
      },
      showSearch: {
        type: Boolean,
        default: false
      },
      filterByServer: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      allowClear: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        dictOptions: [],
        selectedValue: '',
        selectedObject: null,
        loading: false,
        onSearch: null
      }
    },
    watch: {
      dictCode: {
        immediate: true,
        handler() {
          this.initDictData()
        }
      },
      value: {
        immediate: true,
        handler(val) {
          this.selectedValue = val
          // 只在初始化且有值时加载数据
          if (this.showSearch && this.filterByServer && val && !this.dictOptions.length) {
            this.loadData(val)
          }
        }
      }
    },
    created() {
      // 初始化防抖函数
      this.onSearch = debounce(this.loadData, 500)
    },
    methods: {
      initDictData() {
        // 根据字典Code, 初始化字典数组
        if (!this.dictCode) return
        
        // 如果启用了搜索且是服务器过滤模式，则不需要初始加载全部数据
        if (this.showSearch && this.filterByServer) return
        
        this.loading = true
        ajaxGetDictItems(this.dictCode, null).then((res) => {
          this.loading = false
          if (res.success) {
            this.dictOptions = res.result
            // 如果已有选中值，查找对应的文本
            if (this.selectedValue) {
              this.findSelectedObject()
            }
          }
        }).catch(() => {
          this.loading = false
        })
      },
      loadData(value) {
        if (!this.dictCode) return
        if(this.dictCode.indexOf("t_icd_disease") != -1 && (!value || value.trim().length <= 0)) return
        console.log('输入关键词：', value, this.dictCode.indexOf("t_icd_disease") != -1)
        this.loading = true
        // 字典code格式：table,text,code
        const searchValue = value || ''
        getAction(`/sys/dict/getDictItems/${this.dictCode}/${searchValue}`).then(res => {
          this.loading = false
          if (res.success) {
            this.dictOptions = res.result
            // 如果是初始加载并且有选中值，查找对应的对象
            if (this.selectedValue && value === this.selectedValue) {
              this.findSelectedObject()
            }
          } else {
            this.$message.warning(res.message)
          }
        }).catch(() => {
          this.loading = false
        })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleChange(value) {
        this.selectedValue = value
        console.log(this.selectedValue)
        
        // 查找选中项的完整对象
        this.findSelectedObject()
        
        // 触发事件
        if (this.triggerChange) {
          this.$emit('change', this.selectedValue, this.selectedObject.text)
        } else {
          this.$emit('input', this.selectedValue)
          this.$emit('update:object', this.selectedObject)
        }
      },
      findSelectedObject() {
        if (this.multiple) {
          // 多选模式
          if (Array.isArray(this.selectedValue)) {
            this.selectedObject = this.dictOptions.filter(item => 
              this.selectedValue.includes(item.value)
            )
          } else {
            this.selectedObject = []
          }
        } else {
          // 单选模式
          const found = this.dictOptions.find(item => item.value === this.selectedValue)
          this.selectedObject = found || null
        }
      },
      setCurrentDictOptions(dictOptions) {
        this.dictOptions = dictOptions
        // 更新选中项
        this.findSelectedObject()
      },
      getCurrentDictOptions() {
        return this.dictOptions
      },
      // 清空选择
      reset() {
        this.selectedValue = this.multiple ? [] : ''
        this.selectedObject = this.multiple ? [] : null
        this.handleChange(this.selectedValue)
      }
    }
  }
</script>

<style scoped>
</style>